import Button from "../../../components/Button";
import { Input, Select, Textarea } from "../../../components/Inputs";
import moment from "moment";
import { parameterNames, processNames } from "../../../constants/translations";

function inputName(parameterName) {
  if (parameterName === "PIU") {
    return "parameterDecimalValue";
  }
  if (parameterName === "market_reconciliation") {
    return "parameterDateValue";
  }
  return "parameterValue";
}
function inputType(parameterName) {
  if (parameterName === "market_reconciliation") {
    return "date";
  }
  return "number";
}
function inputMin(parameterName) {
  if (
    parameterName === "PIU" ||
    parameterName === "organized_market_default_minimum_price"
  ) {
    return "0";
  }
  if (parameterName === "market_reconciliation") {
    return new Date();
  }
  return "1";
}
const PARAMETERS = {
  edit: function ({ dismiss, save, inputs, inputChange, parameterName, t }) {
    const translations = parameterNames(t);
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>{t("pages.default.systemParameters.updateParameters")}</p>
        <Input
          label={translations[inputs.parameterName]}
          name={inputName(parameterName)}
          value={inputs[inputName(parameterName)]}
          type={inputType(parameterName)}
          min={inputMin(parameterName)}
          acceptDecimal={parameterName === "PIU" ? true : false}
          onChange={inputChange}
        />
        <Input
          label={t("pages.default.systemParameters.startDate")}
          name="startDate"
          value={inputs.startDate}
          min={new Date()}
          type="date"
          onChange={inputChange}
        />
        <Textarea
          label={t("pages.default.systemParameters.modals.description")}
          name="description"
          onChange={inputChange}
          value={inputs.description}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.edit")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
};

const PROCESS = {
  edit: function ({ dismiss, save, inputs, inputChange, processName, t }) {
    const translations = processNames(t);
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>
          {translations[processName]}{" "}
          {t("pages.default.systemParameters.update")}
        </p>
        <Input
          label={t("pages.default.systemParameters.startDate")}
          type="time"
          name="startTime"
          value={`${inputs.startHour ? inputs.startHour : 0}:${
            inputs.startMinute ? inputs.startMinute : 0
          }`}
          onChange={inputChange}
        />
        <Input
          label={t("pages.default.systemParameters.endDate")}
          type="time"
          name="endTime"
          value={`${inputs.endHour ? inputs.endHour : 0}:${
            inputs.endMinute ? inputs.endMinute : 0
          }`}
          onChange={inputChange}
        />
        <Textarea
          label={t("pages.default.systemParameters.modals.description")}
          name="description"
          onChange={inputChange}
          value={inputs.description}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.edit")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
};
const OFF_DAY = {
  delete: function () {
    return null;
  },
  edit: function ({ dismiss, save, inputs, inputChange, t }) {
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>{t("pages.default.systemParameters.updateOffDay")}</p>
        <Input
          label={t("pages.default.systemParameters.table.offDayName")}
          type="text"
          name="offDayName"
          defaultValue={inputs.offDayName}
          disabled
        />
        <Input
          label={t("pages.default.systemParameters.startDate")}
          type="date"
          name="startDate"
          value={inputs.startDate}
          max={inputs.endDate}
          onChange={inputChange}
        />
        <Input
          label={t("pages.default.systemParameters.endDate")}
          type="date"
          name="endDate"
          value={inputs.endDate}
          min={inputs.startDate}
          onChange={inputChange}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.edit")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
  add: function ({ dismiss, save, inputs, inputChange, t }) {
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>{t("pages.default.systemParameters.addOffDayTitle")}</p>
        <Input
          label={t("pages.default.systemParameters.table.offDayName")}
          type="text"
          name="offDayName"
          onChange={inputChange}
        />
        <Input
          label={t("pages.default.systemParameters.startDate")}
          type="date"
          name="offDayStartDate"
          value={inputs.startDate}
          max={inputs.endDate}
          onChange={inputChange}
        />
        <Input
          label={t("pages.default.systemParameters.endDate")}
          type="date"
          name="offDayEndDate"
          value={inputs.endDate}
          min={inputs.startDate}
          onChange={inputChange}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.add")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
};
const SESSION = {
  edit: function ({ dismiss, save, inputs, inputChange, t }) {
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>{t("pages.default.systemParameters.sessionUpdate")}</p>
        <Input
          label={t("pages.default.systemParameters.table.organizedMarketTime")}
          type="date"
          name="sessionDate"
          value={inputs.sessionDate}
          min={new Date()}
          onChange={inputChange}
        />
        <Input
          label={t("pages.default.systemParameters.table.minimumPrice")}
          type="number"
          min="0"
          name="minimumPrice"
          defaultValue={inputs.minimumPrice}
          acceptDecimal
          onChange={inputChange}
        />
        <Input
          label={t("pages.default.systemParameters.table.maximumPrice")}
          type="number"
          min="0"
          name="maximumPrice"
          defaultValue={inputs.maximumPrice}
          acceptDecimal
          onChange={inputChange}
        />
        <Select
          label={t("pages.default.systemParameters.table.status")}
          options={[
            { name: "-", value: "-" },
            { name: t("ui.default.codes.ACTIVE"), value: "ACTIVE" },
            { name: t("ui.default.codes.PASSIVE"), value: "PASSIVE" },
          ]}
          name="status"
          defaultValue={inputs.status}
          onChange={inputChange}
        />
        <Textarea
          label={t("pages.default.systemParameters.modals.description")}
          onChange={inputChange}
          name="description"
          value={inputs.description}
          defaultValue={inputs.description}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.edit")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
  add: function ({ dismiss, save, inputs, inputChange, t }) {
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>{t("pages.default.systemParameters.sessionAdd")}</p>
        <Input
          label={t("pages.default.systemParameters.table.organizedMarketTime")}
          type="date"
          name="sessionDate"
          onChange={inputChange}
          min={new Date()}
          value={inputs.sessionDate}
        />
        <Input
          label={t("pages.default.systemParameters.table.minimumPrice")}
          type="number"
          min="0"
          name="minimumPrice"
          value={inputs.minimumPrice}
          onChange={inputChange}
          acceptDecimal
        />
        <Input
          label={t("pages.default.systemParameters.table.maximumPrice")}
          type="number"
          min="0"
          name="maximumPrice"
          value={inputs.maximumPrice}
          onChange={inputChange}
          acceptDecimal
        />
        <Select
          label={t("pages.default.systemParameters.table.status")}
          options={[
            { name: "-", value: "-" },
            { name: t("ui.default.codes.ACTIVE"), value: "ACTIVE" },
            { name: t("ui.default.codes.PASSIVE"), value: "PASSIVE" },
          ]}
          name="status"
          onChange={inputChange}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.add")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
};
const CONTRACT = {
  edit: function ({
    dismiss,
    save,
    session,
    inputs,
    inputChange,
    contract,
    t,
  }) {
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>{t("pages.default.systemParameters.contractUpdate")}</p>
        <Input
          label={t("pages.default.systemParameters.table.organizedMarketTime")}
          type="text"
          defaultValue={moment(session.sessionDate).format("DD.MM.YYYY")}
          disabled
        />
        <Select
          label={t("pages.default.systemParameters.table.resourceType")}
          options={[
            { name: "-", value: "-" },
            { name: t("ui.default.codes.BIOMASS"), value: "BIOMASS" },
            { name: t("ui.default.codes.WIND"), value: "WIND" },
            { name: t("ui.default.codes.HYDROPOWER"), value: "HYDROPOWER" },
            { name: t("ui.default.codes.GEOTHERMAL"), value: "GEOTHERMAL" },
            { name: t("ui.default.codes.SOLAR"), value: "SOLAR" },
          ]}
          name="type"
          defaultValue={inputs.type}
          onChange={inputChange}
        />
        <Select
          label={t("pages.default.systemParameters.table.status")}
          options={[
            { name: "-", value: "-" },
            { name: t("ui.default.codes.ACTIVE"), value: "ACTIVE" },
            { name: t("ui.default.codes.PASSIVE"), value: "PASSIVE" },
          ]}
          name="status"
          defaultValue={inputs.status}
          onChange={inputChange}
          disabled={contract.status === "PASSIVE"}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.edit")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
  add: function ({ dismiss, save, session, inputChange, t }) {
    return (
      <div className="km__p--system-parameter-modal-content">
        <p>{t("pages.default.systemParameters.contractAdd")}</p>
        <Input
          label={t("pages.default.systemParameters.table.organizedMarketTime")}
          type="text"
          defaultValue={moment(session.sessionDate).format("DD.MM.YYYY")}
          disabled
        />
        <Input
          label={t("pages.default.systemParameters.contractName")}
          type="text"
          name="contractName"
          onChange={inputChange}
        />
        <Select
          label={t("pages.default.systemParameters.table.resourceType")}
          options={[
            { name: "-", value: "-" },
            { name: t("ui.default.codes.BIOMASS"), value: "BIOMASS" },
            { name: t("ui.default.codes.WIND"), value: "WIND" },
            { name: t("ui.default.codes.HYDROPOWER"), value: "HYDROPOWER" },
            { name: t("ui.default.codes.GEOTHERMAL"), value: "GEOTHERMAL" },
            { name: t("ui.default.codes.SOLAR"), value: "SOLAR" },
          ]}
          name="type"
          onChange={inputChange}
        />
        <Select
          label={t("pages.default.systemParameters.table.status")}
          options={[
            { name: "-", value: "-" },
            { name: t("ui.default.codes.ACTIVE"), value: "ACTIVE" },
            { name: t("ui.default.codes.PASSIVE"), value: "PASSIVE" },
          ]}
          name="status"
          onChange={inputChange}
        />
        <div className="km__p--system-parameter-modal-footer">
          <Button
            label={t("ui.default.discard")}
            type="destructive"
            onClick={dismiss}
          />
          <Button label={t("ui.default.add")} type="primary" onClick={save} />
        </div>
      </div>
    );
  },
};

const MODAL_STRUCTURE = {
  PARAMETERS: PARAMETERS,
  PROCESS: PROCESS,
  OFF_DAY: OFF_DAY,
  SESSION: SESSION,
  CONTRACT: CONTRACT,
};

export { MODAL_STRUCTURE };
